
import React, { useState } from 'react';
const ProductCard = ({ product, onAddToCart, onProductClick }) => {
  const [loaded, setLoaded] = useState(false);
  const imgSrc = product.image + (product.updated_at ? `?v=${new Date(product.updated_at).getTime()}` : '');
  return (
    <div
      className="bg-white rounded-xl p-4 flex flex-col text-center cursor-pointer transition-transform transform hover:scale-105 h-full"
      onClick={() => onProductClick(product.id)}
    >
      {/* Imagen centrada con skeleton */}
      <div className="relative w-full aspect-square flex items-center justify-center mb-4 bg-white">
        {!loaded && (
          <div className="absolute inset-0 rounded-lg bg-gray-100 animate-pulse" />
        )}
        <img
          src={imgSrc}
          alt={product.name}
          className={`max-w-full max-h-full object-contain rounded-lg transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
          loading="lazy"
          decoding="async"
          onLoad={() => setLoaded(true)}
        />
      </div>

      {/* Contenido */}
      <div className="flex flex-col flex-grow justify-between">
        <h3 className="text-lg font-semibold text-gray-800 mb-2 min-h-[3.5rem] leading-snug">
          {product.name}
        </h3>

        <p className="text-gray-900 text-xl font-bold mb-4">
          ₡{product.price.toLocaleString('es-CR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>

        <button
          onClick={(e) => {
            e.stopPropagation(); // Evita navegación al hacer clic
            onAddToCart({ ...product, quantity: 1 }); // Asegura que tenga cantidad
          }}
          className="w-full bg-brand text-white py-2 rounded-lg hover:bg-brand/90 transition-colors duration-300 text-sm font-medium mt-auto"
        >
          Agregar al Carrito
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
